import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {IncidentTransaction} from '@npck/af-frontend-api';
import {LocalizationService, Spinner} from '@npck/libs/commons';
import {TransactionForm} from '../transcation-information/transaction-information.component';

@Component({
    selector: 'af-transaction-expansion-panel',
    templateUrl: './transaction-expansion-panel.component.html',
    styleUrl: './transaction-expansion-panel.component.scss',
    standalone: false
})
export class TransactionExpansionPanelComponent {
    @Input() transaction: IncidentTransaction;
    @Input() transactionForm: FormGroup<TransactionForm>;
    @Input() isNew: boolean;
    @Input() showDeleteButton: boolean;
    @Input() showAddTransactionButton: boolean;
    @Input() isAddTransactionButtonDisabled: boolean;
    @Input() index: number;
    @Input() customTitle: string = null;
    @Input() viewIndex: number | string;
    @Output() deleteTransactionListener = new EventEmitter<number>();
    @Output() addNewTransactionListener = new EventEmitter<void>();
    Spinner = Spinner;
    private _expanded = false;
    private wasExpanded = false;

    constructor(
        private localizationService: LocalizationService,
    ) {
    }

    get expanded(): boolean {
        return this._expanded;
    }

    @Input()
    set expanded(value: boolean) {
        if (value) {
            this._expanded = true;
            this.wasExpanded = true;
        } else {
            if (!this.wasExpanded) {
                this._expanded = false;
            }
        }
    }

    getTransactionTitle = (): string => {
        if (this.customTitle) {
            return this.localizationService.getLocalizedKey(this.customTitle);
        }

        const key = this.isNew
            ? 'i18n_af_labelIncidentTransactionNew'
            : 'i18n_af_labelIncidentTransactionTitle';

        return this.localizationService.getLocalizedKey(key, {
            index: this.transaction?.id ?? `№${this.viewIndex}`,
        });
    };
}
